

export enum VarianceAvailabilityStatus{
    OVER,
    UNDER,
    NOT_AVAILABLE,
}
